var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVuesaxlinearkey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policies",
    transform: "translate(-592.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key",
    transform: "translate(592.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.268681,23.7997503 L10.5961823,30.4580847 C10.1145157,30.9539181 9.16534865,31.2514178 8.48534866,31.1522511 L5.3970154,30.7272522 C4.37701536,30.5855855 3.42784878,29.6222522 3.27201544,28.6022522 L2.84701553,25.5139184 C2.74784886,24.8339184 3.07368222,23.8847521 3.54118223,23.4030854 L10.1995154,16.744751 C9.06618203,13.0614178 9.94451563,8.88225104 12.8628489,5.97808444 C17.0420156,1.79891771 23.8278506,1.79891771 28.021184,5.97808444 C32.2145174,10.1572512 32.2145177,16.9714184 28.035351,21.1505852 C25.1170177,24.0547518 20.9378476,24.9472503 17.268681,23.7997503 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.76033529,
    y1: 24.777832,
    x2: 13.0186682,
    y2: 28.036167,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5416667,15.5833333 C19.3680616,15.5833333 18.4166667,14.6319384 18.4166667,13.4583333 C18.4166667,12.2847282 19.3680616,11.3333333 20.5416667,11.3333333 C21.7152718,11.3333333 22.6666667,12.2847282 22.6666667,13.4583333 C22.6666667,14.6319384 21.7152718,15.5833333 20.5416667,15.5833333 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,5.03301104e-15 L34,34 L0,34 L0,5.03301104e-15 L34,5.03301104e-15 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(17.000000, 17.000000) rotate(-180.000000) translate(-17.000000, -17.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxlinearkey);
export default __webpack_public_path__ + "static/media/vuesaxlinearkey.bc5bd4cbda75743885b515053097344f.svg";
export { ForwardRef as ReactComponent };